export function saturatef(x) {
    return x >= 0.0 ? (x <= 1.0 ? x : 1.0) : 0.0;
}
export function hue(vec, h) {
    vec.x = saturatef(Math.abs(h * 6.0 - 3.0) - 1.0);
    vec.y = saturatef(2.0 - Math.abs(h * 6.0 - 2.0));
    vec.z = saturatef(2.0 - Math.abs(h * 6.0 - 4.0));
}
var Vec4 = /** @class */ (function () {
    function Vec4(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    return Vec4;
}());
export { Vec4 };
//# sourceMappingURL=vec4.js.map